 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		12: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"3bb96afdb02519cdaff3e06f6cea933bbe866088","3":"b7d770fb6fe7d6310f8a39d1572837ffa42bac2a","4":"fb3830759bafe05119cf5c4fa6b409a51aa59497","5":"eff6ed68d49829f16681784a860a7b3d376df283","6":"64963da5e61b279d4f47f506bed365bcef2f13ae","7":"b8fada49f016de40082cca63aec36dc1d875418e","8":"227d60df08653fcdaaad4f0305a2b70e3ce440da","9":"b5f86651182099da8926e4d999d4c26a4d65e3d3","10":"e810926f1ce48e05b1d26c371c805d7b1d7215e7","11":"framework","14":"component---gatsby-theme-gaviscon-src-templates-article-listing-page-article-listing-page-tsx","15":"component---gatsby-theme-gaviscon-src-templates-article-page-article-page-tsx","16":"component---gatsby-theme-gaviscon-src-templates-home-page-home-page-tsx","17":"component---gatsby-theme-gaviscon-src-templates-landing-page-landing-page-tsx","18":"component---gatsby-theme-gaviscon-src-templates-lds-page-lds-page-tsx","19":"component---gatsby-theme-gaviscon-src-templates-plain-page-plain-page-tsx","20":"component---gatsby-theme-gaviscon-src-templates-product-listing-page-product-listing-page-tsx","21":"component---gatsby-theme-gaviscon-src-templates-quiz-page-quiz-page-tsx","22":"component---gatsby-theme-gaviscon-src-templates-search-result-page-search-result-page-tsx","23":"component---gatsby-theme-gaviscon-src-templates-symptom-page-symptom-page-tsx","24":"component---gatsby-theme-gaviscon-src-templates-symptoms-campaign-page-symptoms-campaign-page-tsx","25":"component---src-gatsby-theme-gaviscon-pages-404-tsx","26":"component---src-gatsby-theme-gaviscon-templates-product-page-product-page-tsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"9ae0fc882b52ae6ca550","2":"407a647bd008c8ca1dea","3":"97d7293e823e520cd070","4":"ea50ce39c763c357b410","5":"61b875a37fe73eb6ed85","6":"247c43cb639a0d61e773","7":"8d3c1bd2b21f6fba424f","8":"5a4040109b7da1e6b8d4","9":"c0ea1c5339566e4345ce","10":"1c09c0a21c5199f2ca8d","11":"708b3b292bb3930cfc76","14":"29954988d2a1a1678445","15":"a063c723e2dcac63f748","16":"05a2eea225e1e54f5478","17":"ec2965cd3205f660f785","18":"9af4c945afc0107ac1c8","19":"53656ed3d3279f1e11b7","20":"fbfde2925bbb461f35c6","21":"7cd1eb2d46dcb7b524d7","22":"2f2e6241b5601bc6f6ab","23":"0c34c57728dc85b254b2","24":"14d6c842f0d45137286d","25":"52a86be06947c8caac5e","26":"bf15def9a2375d196329","28":"7985fb2306a3ec922dc6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"3bb96afdb02519cdaff3e06f6cea933bbe866088","3":"b7d770fb6fe7d6310f8a39d1572837ffa42bac2a","4":"fb3830759bafe05119cf5c4fa6b409a51aa59497","5":"eff6ed68d49829f16681784a860a7b3d376df283","6":"64963da5e61b279d4f47f506bed365bcef2f13ae","7":"b8fada49f016de40082cca63aec36dc1d875418e","8":"227d60df08653fcdaaad4f0305a2b70e3ce440da","9":"b5f86651182099da8926e4d999d4c26a4d65e3d3","10":"e810926f1ce48e05b1d26c371c805d7b1d7215e7","11":"framework","14":"component---gatsby-theme-gaviscon-src-templates-article-listing-page-article-listing-page-tsx","15":"component---gatsby-theme-gaviscon-src-templates-article-page-article-page-tsx","16":"component---gatsby-theme-gaviscon-src-templates-home-page-home-page-tsx","17":"component---gatsby-theme-gaviscon-src-templates-landing-page-landing-page-tsx","18":"component---gatsby-theme-gaviscon-src-templates-lds-page-lds-page-tsx","19":"component---gatsby-theme-gaviscon-src-templates-plain-page-plain-page-tsx","20":"component---gatsby-theme-gaviscon-src-templates-product-listing-page-product-listing-page-tsx","21":"component---gatsby-theme-gaviscon-src-templates-quiz-page-quiz-page-tsx","22":"component---gatsby-theme-gaviscon-src-templates-search-result-page-search-result-page-tsx","23":"component---gatsby-theme-gaviscon-src-templates-symptom-page-symptom-page-tsx","24":"component---gatsby-theme-gaviscon-src-templates-symptoms-campaign-page-symptoms-campaign-page-tsx","25":"component---src-gatsby-theme-gaviscon-pages-404-tsx","26":"component---src-gatsby-theme-gaviscon-templates-product-page-product-page-tsx"}[chunkId]||chunkId) + "." + {"0":"1f8677e7712addba2371","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
